<button id="span" class="btn-mobile" (click)="openNav()">&#9776; Filtri</button>
<div id="sidebar-filter" class="filter">
	<form [formGroup]="filterForm">
		<h4>Filtri <button id="span" href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</button>
		</h4>

		<div class="flex" id="sidebar">
			<div *ngIf="listType != 'scadute' && listType != 'rifiutati'" class="form-group">
				<h6>Operatore</h6>
				<!-- <select class="form-control" id="operator_selector" (change)="setFilter('operatore', $event)"
					formControlName="filterOperator">
					<option [value]="null">Tutti</option>
					<option value="insoorer">Insoorer</option>
					<option value="videoperatore">Videooperatori</option>
					<option value="peritoesterno">Periti Esterni</option>
				</select> -->
				<ng-multiselect-dropdown [formControl]="filterForm.controls['filterOperatore']" name="operatorii"
					(onFilterChange)="setFilter('operatore', { target: { value: operatori } })" [placeholder]="'Tutti'"
					[settings]="operatoriSettings" [data]="operatoriList"
					(onSelect)="setFilter('operatore',  { target: { value: operatori } })"
					(onDeSelect)="setFilter('operatore',  { target: { value: operatori } })">
				</ng-multiselect-dropdown>
			</div>
			<div class="form-group">
				<h6>Anno</h6>
				<select class="form-control" id="company_selector" (change)="setFilter('anno', $event)"
					formControlName="filterAnno">
					<option *ngFor="let item of filterConfiguration; let idx = index;" [value]="item.value">
						{{item.label}}</option>
				</select>
			</div>
			<div *ngIf="listType != 'rifiutati'" class="form-group">
				<h6>Mese</h6>
				<select class="form-control" id="company_selector" (change)="setFilter('mese', $event)"
					formControlName="filterMese">
					<option *ngFor="let m of months; let idx = index;" [value]="m">{{getMonthName(m)}}</option>
				</select>
			</div>
			<div *ngIf="listType != 'scadute'" class="form-group">
				<h6>Tipo Pagamento</h6>
				<select class="form-control" id="type_selector" (change)="setFilter('tipologiaPagamento', $event)"
					formControlName="filterTipologia">
					<option [value]="-1">Tutti</option>
					<option [value]="0">Ricevuta</option>
					<option [value]="1">Fattura</option>
				</select>
			</div>
			<div *ngIf="listType == 'rifiutati'" class="form-group">
				<h6>Tipo Utente</h6>
				<select class="form-control" id="type_selector" (change)="setFilter('tipologiaUtente', $event)"
					formControlName="filterTipologiaUtente">
					<option [value]="-1">Tutti</option>
					<option [value]="0">Insoorer</option>
					<option [value]="1">Perito Interno</option>
					<option [value]="2">Perito Esterno</option>
				</select>

			</div>
		</div>
	</form>
</div>